module.exports = __webpack_public_path__ + "static/media/parkhub-live-logo-black.a424e16a.svg";